import React, { useEffect } from 'react';
import { Field, ErrorMessage } from 'formik';

const Step3 = ({ values, setFieldValue }) => {
    const isEsnEmail = values.email?.endsWith('@esnlisboa.org');

    useEffect(() => {
        if (isEsnEmail) {
            setFieldValue('institutionalEmail', values.email);
        } else {
            setFieldValue('personalEmail', values.email);
        }
    }, [isEsnEmail, values.email, setFieldValue]);

    return (
        <div style={{ width: '100%', maxWidth: '400px' }}>
            <p style={{ fontStyle: 'italic', textAlign: 'justify' }}>Almost done! Just a few more details to complete your registration</p>

            <div className={"main-descriptions user-title"} style={{ width: '100%', marginTop: '20px' }}>
                Contact Information
            </div>

            {isEsnEmail && (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <label htmlFor="personalEmail">Personal Email</label>
                    <Field name="personalEmail" placeholder="dina@gmail.com" className='login-input' style={{ marginTop: '5px' }} />
                    <ErrorMessage name="personalEmail" component="div" style={{ color: '#CD3E3D' }} />
                </div>
            )}

            {!isEsnEmail && (
                <div style={{ display: 'flex', flexDirection: 'column', marginTop: '10px' }}>
                    <label htmlFor="institutionalEmail">ESN Email <i>(if you have one)</i></label>
                    <Field name="institutionalEmail" placeholder="dina@esnlisboa.org" className='login-input' style={{ marginTop: '5px' }} />
                    <ErrorMessage name="institutionalEmail" component="div" style={{ color: '#CD3E3D' }} />
                </div>
            )}

            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '10px' }}>
                <label htmlFor="phone">Phone Number</label>
                <Field name="phone" placeholder="123456789" className='login-input' style={{ marginTop: '5px' }} />
                <ErrorMessage name="phone" component="div" style={{ color: '#CD3E3D' }} />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '10px' }}>
                <label htmlFor="address">Address</label>
                <Field name="address" placeholder="123 Street, City, Country" className='login-input' style={{ marginTop: '5px' }} />
                <ErrorMessage name="address" component="div" style={{ color: '#CD3E3D' }} />
            </div>
        </div>
    );
};

export default Step3;
